export const fptiConstants = {
    SPACE_KEY: 'SKYGOV',
    FPTI_ERROR_MESSAGE: 'FPTI tracking error',
}

export const fptiEvents = {
    API_PERFORMANCE: 'API_PERFORMANCE',
    DEPRECATION_WARNING_CANCEL: 'DEPRECATION_WARNING_CANCEL',
    DEPRECATION_WARNING_PPCP_LINK: 'DEPRECATION_WARNING_PPCP_LINK',
    DEPRECATION_WARNING_CONTINUE: 'DEPRECATION_WARNING_CONTINUE',
    DEPRECATION_WARNING_VIEW: 'DEPRECATION_WARNING_VIEW',
    MERCHANT_SEGMENTATION_RESPONSE: 'MERCHANT_SEGMENTATION_RESPONSE',
}
